<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <!-- <v-autocomplete
              :items="plants"
              item-text="name"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
              :rules="powerPlantRules"
            ></v-autocomplete> -->
            <v-autocomplete
              :items="plants"
              item-text="name"
              prepend-icon="flash_on"
              label="Planta"
              v-model="power_plant"
              return-object
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 md2>
            <v-text-field
              v-model="competence"
              label="Competencia"
              prepend-icon="event"
              class="purple-input"
              @keyup.enter="validate"
              mask="##/####"
              return-masked-value
            />
            <!-- <v-text-field
              v-model="competence"
              :rules="competenceRules"
              label="Competencia"
              prepend-icon="event"
              class="purple-input"
              @keyup.enter="validate"
              mask="##/####"
              return-masked-value
            /> -->
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="consumer_unit"
              label="Unidade Consumidora"
              prepend-icon="home"
              class="purple-input"
              @keyup.enter="validate"
            />
          </v-flex>
          <v-flex xs12 md4 class="text-lg-right">
            <v-btn
              color="warning"
              @click="clear()"
              :disabled="loadingNotBilled"
              :loading="loadingNotBilled"
              small
              outline
              slot="start"
            >
              <v-icon>close</v-icon>Limpar
            </v-btn>
            <v-btn
              color="primary"
              @click="validate()"
              :disabled="loadingNotBilled"
              :loading="loadingNotBilled"
              small
              outline
              slot="start"
            >
              <v-icon>search</v-icon>Buscar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      power_plant: null,
      competence: null,
      consumer_unit: null,
      projected: true,
      valid: false,
      error: true,
      powerPlantRules: [
        (v) => !!v || "Selecione a Planta que deseja ver fatura",
      ],
      competenceRules: [
        (v) => !!v || "Por favor, preencher a competência da fatura.",
        (v) =>
          (v && !(v.substr(3, 7) < 2019)) ||
          "Por favor, o ano deve ser valido. " + v?.substr(2, 4),
        (v) =>
          (v && !(v.substr(0, 2) > 12)) ||
          "Por favor, o mes deve ser valido. " + v?.substr(0, 2),
      ],
    };
  },

  created() {
    if (this.plants && this.plants.length <= 0) {
      this.getPlants();
    }
  },

  computed: {
    ...mapState("configuration", ["plants"]),
    ...mapState("billing", ["loadingNotBilled"]),
  },

  methods: {
    ...mapActions("configuration", ["getPlants"]),
    ...mapActions("billing", ["getNotBilledUCs"]),

    async validate() {
      if (this.$refs.form.validate()) {
        if (!this.consumer_unit && !this.power_plant) {
          this.error = true;
          return true;
        }
        // this.loading = true
        let params = {};

        if (this.consumer_unit) params.consumer_unit = this.consumer_unit;

        if (this.power_plant && this.competence) {
          const splitCompetence = this.competence.split("/");
          const formatedCompetence = `${splitCompetence[1]}-${splitCompetence[0]}`;
          params = {
            ...params,
            power_plant: this.power_plant,
            competence: formatedCompetence,
          };
        }
        await this.getNotBilledUCs(params);
        // this.loading = false
      }
    },
    clear() {
      this.power_plant = null;
      this.competence = null;
      this.consumer_unit = null;
      this.projected = true;
      this.valid = false;
      this.$store.commit("billing/setNotBilledUCs", []);
    },
  },
};
</script>
